<template>
  <div class="row audio-player__title">
    <div class="col-2 d-flex justify-content-start align-items-center pl-0">
      <span class="time-indicator time-indicator--current text-small">
        {{ getFormattedTime(currentTime) }}
      </span>
    </div>

    <div
      class="col-8 audio-player__chapter-title-wrapper d-flex justify-content-center align-items-center"
    >
      <BaseButton
        variant="naked"
        class="reset-btn-styling h-100 d-flex flex-row align-items-center overflow-hidden"
        data-testid="toggleChaptersBtn"
        @click="toggleChaptersList"
      >
        <span class="audio-player__chapter-title text-label">
          {{ chapterTitle }}
        </span>
        <span
          v-if="showOrderNumber"
          class="audio-player__order fw-medium text-small"
        >
          &nbsp;{{ chapterOrder }}
        </span>

        <ListIcon />
      </BaseButton>
    </div>

    <div class="col-2 d-flex justify-content-end align-items-center pr-0">
      <span class="time-indicator time-indicator--left text-small">
        -{{ getFormattedTime(duration - currentTime) }}
      </span>
    </div>
  </div>
</template>

<script>
import ListIcon from '~/assets/icons/list.svg'
import { formatTime } from '~/utils'

export default {
  components: {
    ListIcon,
  },
  props: {
    activeChapter: {
      type: Object,
      default: () => ({}),
    },
    currentTime: {
      type: Number,
      default: 0,
    },
    duration: {
      type: Number,
      default: 0,
    },
    bookTitle: {
      type: String,
      default: '',
    },
    chapters: {
      type: Array,
      default: () => [],
    },
    toggleChaptersList: {
      type: Function,
      default: () => {},
    },
    chaptersListOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chapterTitle() {
      return this.activeChapter.order
        ? this.activeChapter.chapter
        : this.bookTitle
    },
    showOrderNumber() {
      return this.chapters && this.chapters.length
    },
    chapterOrder() {
      return `(${this.activeChapter.order}/${this.chapters.length})`
    },
  },
  methods: {
    getFormattedTime(time) {
      return formatTime(time)
    },
  },
}
</script>

<style lang="scss" scoped>
.audio-player__title {
  margin-left: 0px;
  margin-right: 0px;
}

.audio-player__chapter-title-wrapper {
  padding-left: 8px;
  padding-right: 8px;
}

.audio-player__chapter-title,
.audio-player__order {
  text-align: center;
}

svg {
  margin-left: 7px;
  padding-right: 1px;
}

.audio-player__order {
  font-weight: normal;
}

.audio-player__chapter-title {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

@include media-breakpoint-up(md) {
  .audio-player__chapter-title-wrapper {
    padding-left: 16px;
    padding-right: 16px;
  }

  svg {
    margin-left: 8px;
  }
}
</style>
